var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#020002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.563 15.523V14.47l1.32-1.154a1.375 1.375 0 0 0 .26-1.753l-1.622-2.75a1.376 1.376 0 0 0-1.629-.62l-1.67.565a7.803 7.803 0 0 0-.901-.516l-.35-1.733a1.375 1.375 0 0 0-1.376-1.106h-3.217a1.375 1.375 0 0 0-1.375 1.106l-.351 1.733a7.888 7.888 0 0 0-.907.516l-1.637-.592a1.375 1.375 0 0 0-.44-.04 1.375 1.375 0 0 0-1.19.687l-1.622 2.75a1.375 1.375 0 0 0 .282 1.725l1.3 1.19v1.052l-1.3 1.155a1.375 1.375 0 0 0-.282 1.753l1.623 2.75a1.375 1.375 0 0 0 1.19.687c.149.001.297-.022.44-.069l1.67-.563c.288.191.59.364.9.515l.351 1.733a1.375 1.375 0 0 0 1.375 1.107h3.245a1.375 1.375 0 0 0 1.375-1.107l.35-1.733a7.88 7.88 0 0 0 .908-.515l1.664.563a1.375 1.375 0 0 0 1.63-.619l1.567-2.75a1.375 1.375 0 0 0-.282-1.725l-1.3-1.19zM21.332 20.5l-2.358-.797a6.092 6.092 0 0 1-1.863 1.079l-.488 2.468h-3.245l-.489-2.44a6.437 6.437 0 0 1-1.856-1.08l-2.365.77-1.622-2.75 1.87-1.65a6.119 6.119 0 0 1 0-2.152l-1.87-1.698L8.668 9.5l2.358.798a6.09 6.09 0 0 1 1.864-1.08l.488-2.468h3.245l.488 2.44a6.434 6.434 0 0 1 1.856 1.08l2.365-.77 1.622 2.75-1.87 1.65a6.12 6.12 0 0 1 0 2.152l1.87 1.698-1.622 2.75z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.125A4.125 4.125 0 1 1 19.125 15 4.084 4.084 0 0 1 15 19.125zm0-6.875A2.688 2.688 0 0 0 12.25 15 2.687 2.687 0 0 0 15 17.75 2.687 2.687 0 0 0 17.75 15 2.688 2.688 0 0 0 15 12.25z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settingsIcon.904e527794051997954d20e791bef489.svg";
export { ForwardRef as ReactComponent };